import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Hand from "../imgs/handStones.png";
import { useTranslation } from "react-i18next";
import {Link} from "react-router-dom";

export default function MoreServices() {
  const { t } = useTranslation();
  const services = t("other_services_list", { returnObjects: true }) || [];
  return (
    <section className="section center more-services" id="moreServices">
      <Container className="content  ">
        <Row>
          <Col  md={6}>
            <div className="contact-me ">
              {/*<h2>{t("additional_offers")}</h2>*/}
              <h2>{t("contact")}</h2>
              {/*<p> Möchtest du ein <strong>kostenloses Kennenlerngespräch</strong>  (20 Minuten) oder eine <strong>Heilreise</strong>  mit mir buchen?</p>*/}
              {/*  <p>Ich freue mich, dich auf deinem Weg zu begleiten!</p>*/}

              {/*<p>  Schreib mir einfach eine Nachricht per <strong> E-Mail, Telegram oder WhatsApp,</strong>  und gib mir bitte <strong>drei Terminvorschläge,</strong>  die für dich passen.</p>*/}
              {/*<p> Ich melde mich schnellstmöglich bei dir, um einen passenden Termin zu bestätigen.</p>*/}

                <p dangerouslySetInnerHTML={{ __html: t("footer_contact_me") }} />{" "}

              <div className="col-md-6 contact-info">
              <ul style={{ zIndex: "5" }} className="list-unstyled">
                <li>
                  <i className="bi bi-envelope-fill"></i> joannacwalinaa@gmail.com
                </li>
                <li>
                  <i className="bi bi-telephone-fill"></i> +49 1577 2195452
                </li>

                {/*<li>*/}
                {/*  <i className="bi bi-instagram"></i>{" "}*/}
                {/*  <Link*/}
                {/*      to="https://www.instagram.com/joanna_cwalina"*/}
                {/*      target="_blank"*/}
                {/*      rel="noopener noreferrer"*/}
                {/*  >*/}
                {/*    joanna_cwalina*/}
                {/*  </Link>*/}
                {/*</li>*/}
              </ul>
              </div>

              {/*<ul>*/}
              {/*  {Array.isArray(services) && services.length > 0 ? (*/}
              {/*    services.map((service, index) => (*/}
              {/*      <li key={index}>{service}</li>*/}
              {/*    ))*/}
              {/*  ) : (*/}
              {/*    <li></li>*/}
              {/*  )}*/}
              {/*</ul>*/}
              {/*<div className="pt-3">*/}
              {/*  <p>*/}
              {/*    <strong> {t("pricing.coaching")}</strong>{" "}*/}
              {/*    {t("pricing.coachingPrice")}*/}
              {/*  </p>*/}
              {/*  <p style={{ marginBottom: "0" }}>*/}
              {/*    <strong>{t("pricing.clearing")}</strong>{" "}*/}
              {/*    {t("pricing.clearingPrice")}*/}
              {/*  </p>*/}
              {/*</div>*/}
            </div>
          </Col>
          <Col md={6} className=" center">
            <img src={Hand} alt="Chakra Healing" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
